module.exports = ".modal-header {\n  padding: 5px !important; }\n\n#Askdelete {\n  margin: 30px auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/history/history.component.scss
// module id = ./client/app/history/history.component.scss
// module chunks = main